/**
 * Created by Ivan on 10.08.2026
 */

const StickersBookToolbarItem2 = function () {
    if (cleverapps.config.features.includes("season_collections2")) {
        delete ToolbarItem.STICKERS_BOOK2.force;
    }

    ToolbarItem.call(this, ToolbarItem.STICKERS_BOOK2);

    this.enable();

    cleverapps.stickersBook2.onChangeAttentionListener = this.onChangeState.bind(this);
    this.onChangeState();
};

StickersBookToolbarItem2.prototype = Object.create(ToolbarItem.prototype);
StickersBookToolbarItem2.prototype.constructor = StickersBookToolbarItem2;

StickersBookToolbarItem2.prototype.onChangeState = function () {
    if (cleverapps.stickersBook2.hasAttention()) {
        this.mark();
    } else {
        this.unmark();
    }
};

StickersBookToolbarItem2.prototype.onClick = function () {
    const activeTutorial = cleverapps.tutorial.getActive();

    cleverapps.focusManager.display({
        focus: "StickersBook2",
        stack: StickersBookStartTutorial2 && activeTutorial && activeTutorial.name === StickersBookStartTutorial2.NAME,
        action: function (f) {
            cleverapps.tutorial.trigger("stickers2_book_toolbar_item_clicked");

            cleverapps.focusManager.onceNoWindowsListener = f;
            new StickersBookWindow2(cleverapps.stickersBook2);
        }
    });
};

StickersBookToolbarItem2.prototype.isVisible = function () {
    return cleverapps.stickersBook2.isAvailable() && cleverapps.stickersBook2.isVisibleInScene();
};
